export const REFER_GRADIENT_TEXT: string = 'You both earn $5'
export const REFER_HEADER_TEXT: string = 'Refer a friend'
export const REFER_BODY_TEXT: string =
    'Refer a friend and earn discounts on your next purchase!'
export const REFER_BUTTON_TEXT: string = 'Refer now'
export const REFER_IMAGE_GROUP: string =
    'https://res.cloudinary.com/gift-card-granny/image/upload/v1718141095/PGSite/marketing_images/image-horizontal-banner-2-desktop_fzfrjb.png'
export const REFER_IMAGE_GIRLS: string =
    'https://res.cloudinary.com/gift-card-granny/image/upload/v1717793539/PGSite/marketing_images/two-girls-with-dog_y07i7t.png'
export const REFER_IMAGE_FIST_BUMP: string =
    'https://res.cloudinary.com/gift-card-granny/image/upload/v1718389659/PGSite/marketing_images/fist-bump_oszham.png'
